import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { authSelector } from 'store/authState';
import { useAppSelector } from 'hooks/redux';

import Navbar from 'components/fragments/Navbar';

import { Main } from './styled';

const Layout: FC = () => {
  const location = useLocation();
  const { session } = useAppSelector(authSelector);

  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar authenticated={session.authenticated} />
      <Main>
        <Outlet />
      </Main>
    </>
  );
};

export default Layout;
